import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initialname'
})
export class InitialnamePipe implements PipeTransform {

  transform(name: any): any {

    if (name && typeof name === 'string') {
  
      if (/^\d+$/.test(name)) {
        return name.charAt(0);
      }

      const words = name.split(' ');

      const initial: string[] = [];

      words.forEach(letter => {
        if (letter.length > 0) {
          initial.push(letter.charAt(0));
        }
      });

      return initial.slice(0, 2).join('').toLocaleUpperCase();
    }

    return '';
  }

}
